// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';
import { CircularProgressBar } from '@pixi/ui';

const raw = {
  list: [
    {
      id: '76685e30-a1c1-4bb1-85c9-7931f03bc192',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '2ce705bf-e8fb-4b1c-853f-39cf89ed1790',
      type: 'Container',
      name: 'progressContainer',
      className: '',
      x: 50,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '76685e30-a1c1-4bb1-85c9-7931f03bc192'
    },
    {
      id: '3d17af65-411c-46e4-8879-7a87ceb936cb',
      type: 'Container',
      runtimeType: 'CircularProgressBar',
      name: 'circularProgressBar',
      className: '',
      x: -15,
      y: -5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2ce705bf-e8fb-4b1c-853f-39cf89ed1790',
      data: {
        constructorParams: {
          backgroundColor: 16777215,
          backgroundAlpha: 1,
          fillColor: 6471756,
          radius: 20
        }
      },
      stateByName: {
        ready: {
          visible: false
        }
      }
    },
    {
      id: '273082c4-e4e1-4efd-8af3-3ee5b75ca55a',
      type: 'Text',
      name: 'rewardText',
      className: '',
      x: 28,
      y: 0,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Reward Ready in <adFallbackCountdownSec>s',
      localize: true,
      maxWidth: 555,
      maxHeight: 92,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '2ce705bf-e8fb-4b1c-853f-39cf89ed1790',
      data: {
        translations: {
          'Reward Ready in <adFallbackCountdownSec>s': {
            en_US: 'Reward Ready in <adFallbackCountdownSec>s',
            it_IT: 'Ricompensa pronta tra <adFallbackCountdownSec>s',
            fr_FR: 'Récompense prête dans <adFallbackCountdownSec>s',
            de_DE: 'Belohnung bereit in <adFallbackCountdownSec>s',
            es_ES: 'Recompensa lista en <adFallbackCountdownSec>s',
            pt_PT: 'Recompensa pronta em <adFallbackCountdownSec>s',
            pl_PL: 'Nagroda gotowa za <adFallbackCountdownSec>s',
            nl_NL: 'Beloning klaar over <adFallbackCountdownSec>s',
            ko_KR: '<adFallbackCountdownSec>초 후 보상 준비 완료',
            ja_JP: '<adFallbackCountdownSec>秒後に報酬の準備完了'
          },
          'Reward Ready': {
            en_US: 'Reward Ready',
            it_IT: 'Ricompensa pronta',
            fr_FR: 'Récompense prête',
            de_DE: 'Belohnung bereit',
            es_ES: 'Recompensa lista',
            pt_PT: 'Recompensa pronta',
            pl_PL: 'Nagroda gotowa',
            nl_NL: 'Beloning klaar',
            ko_KR: '보상 준비 완료',
            ja_JP: '報酬の準備完了'
          }
        }
      },
      stateByName: {
        ready: {
          text: 'Reward Ready'
        },
        notReady: {
          text: 'Reward Ready in <adFallbackCountdownSec>s'
        }
      }
    },
    {
      id: '705bb794-a634-475b-9d1a-d7d39af1d2e6',
      type: 'Sprite',
      name: '',
      className: '',
      x: -11,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Check',
      parent: '2ce705bf-e8fb-4b1c-853f-39cf89ed1790',
      stateByName: {
        ready: {
          visible: true
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 760,
  version: '4.0.1',
  stateNames: [
    'ready',
    'notReady'
  ],
  handleResize: false
} as const;

export class AdCountdownViewLayout {
  static raw = raw;
  root!: Container;
  progressContainer!: Container;
  circularProgressBar!: CircularProgressBar & { data: typeof raw['list'][2]['data'] };
  rewardText!: Text & { data: typeof raw['list'][3]['data'] };
  StateName!: 'ready' | 'notReady';

  constructor() {
    populate(this, raw);
  }
}
